import * as XLSX from "xlsx";

export class ExcelGeneratorService {
  freezeFirstRow(worksheet: XLSX.WorkSheet): void {
    if (!worksheet["!ref"]) return;
    worksheet["!freeze"] = { xSplit: 0, ySplit: 1 };
  }

  writeWorkbook(workbook: XLSX.WorkBook): Uint8Array<ArrayBufferLike> {
    const buffer = XLSX.write(workbook, { type: "array", bookType: "xlsx" }) as ArrayBufferLike;
    return new Uint8Array(buffer);
  }

  createFile(
    buffer: Uint8Array<ArrayBufferLike>,
    filename: string
  ): { filename: string; buffer: Uint8Array<ArrayBufferLike> } {
    return { filename, buffer };
  }
}
